<template>
  <b-modal
    id="availableinvoice"
    size="lg"
    ref="availableinvoice"
    body-class="bg-white"
    cancel-title="Close"
    cancel-variant="light"
    ok-title="Apply Invoice"
    :ok-title-html="
      submitted == true ? loaderIcon + 'Apply Invoice' : 'Apply Invoice'
    "
    :title="title"
    :no-close-on-backdrop="true"
    @shown="createFreshObject()"
    @ok.prevent="onSubmit()"
    :lazy="true"
  >
    <b-alert
      class="alert-transparent alert-danger"
      :show="(alertShow = error_show && this.errors.any())"
    >
      <button type="button" @click="error_show = false" class="close">
        <span aria-hidden="true">&times;</span>
      </button>

      <p
        class="text-danger"
        v-if="errors.has('paid_amount')"
      >Please enter the valid amount to be applied to invoice(s).</p>
    </b-alert>
    <span class="text-bold float-right">
      <strong>
        {{
        currency +
        parseFloat(field.unused_amount).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
        })
        }}
      </strong>
    </span>
    <span class="text-bold float-right mr-2">
      <strong>Balance :</strong>
    </span>
    <br />
    <!--  table for showing availabel credit details -->
    <div class="table-responsive mt-4">
      <table class="table table-hover">
        <thead>
          <th>INVOICE NO.</th>
          <th>INVOICE DATE</th>
          <th class="text-right">INVOICE AMOUNT</th>
          <th class="text-right">INVOICE BALANCE</th>
          <th class="text-right">AMOUNT</th>
          <th></th>
        </thead>
        <template v-if="items.length == 0">
          <tbody>
            <tr>
              <td colspan="6" class="text-center">No invoice to display</td>
            </tr>
          </tbody>
        </template>
        <template v-else>
          <tbody>
            <tr v-for="(item, index) in items" :key="item.id">
              <td>{{ item.inv_no }}</td>
              <td>{{ getDateFormat(item.created_date) }}</td>
              <td class="text-right">
                {{
                currency +
                parseFloat(item.grand_total).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
                })
                }}
              </td>
              <td class="text-right">
                {{
                currency +
                parseFloat(item.due_amount).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
                })
                }}
              </td>
              <td>
                <input
                  type="text"
                  class="form-control text-right"
                  v-model.trim="item.used_amount"
                  @blur="total(), checkAdvance(index)"
                />
              </td>
              <td></td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="4" class="text-right">Amount:</td>
              <td class="text-right">{{ currency + header.paid_amount }}</td>
            </tr>
            <tr>
              <td colspan="4" class="text-right" style="border-top:none">Amount Available:</td>
              <td
                class="text-right"
                style="border-top:none"
              >{{ currency + field.apply_unused_amount }}</td>
            </tr>
          </tfoot>
        </template>
      </table>
      <input
        type="hidden"
        name="paid_amount"
        :value="header.paid_amount"
        v-validate="
          'required|between:0,' +
            field.unused_amount +
            '|excluded:' +
            parseFloat(0).toFixed(2) +
            '|max_value:' +
            parseFloat(field.unused_amount).toFixed(2)
        "
      />
    </div>
  </b-modal>
</template>
<script>
import { mapState } from "vuex";
import store from "@/store/index";
import { notificationMixin } from "@/mixins/notification";

import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component

export default {
  props: ["title", "check", "page", "currency"], // field data form parent component
  mixins: [notificationMixin], // for showing message notification
  data() {
    return {
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      checkCustomerAdvance: {},
      field: {},
      header: {
        paid_amount: "0.00"
      },
      alertShow: "", // to show the error message
      error_show: false, // to show the error message
      items: [], // credit available details
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center" // class for notification message design
    };
  },
  methods: {
    checkAdvance(i) {
      if (
        this.items[i].pymnt_type == 4 &&
        this.items[i].place_of_supply != this.field.place_of_supply &&
        this.items[i].used_amount > 0
      ) {
        this.checkCustomerAdvance[i] = 1;
      } else {
        delete this.checkCustomerAdvance[i];
      }
    },
    // calculation for using credit amount for tallyign invoice
    total() {
      var header_unused_amount = parseFloat(this.field.unused_amount);
      var header_amount = this.items.reduce(function(total, value) {
        var available_amount = parseFloat(value.due_amount);
        var used_amount = parseFloat(value.used_amount);
        if (
          used_amount > available_amount ||
          used_amount > header_unused_amount
        ) {
          value.used_amount =
            header_unused_amount <= available_amount
              ? header_unused_amount
              : available_amount;
        }
        header_unused_amount -= value.used_amount;
        return !isNaN(parseFloat(value.used_amount))
          ? total + parseFloat(value.used_amount)
          : parseFloat(total);
      }, 0);
      this.header.paid_amount = header_amount.toFixed(2);
      var unused_amount =
        parseFloat(this.field.unused_amount) - parseFloat(header_amount);
      this.field.apply_unused_amount = unused_amount.toFixed(2);
    },
    createFreshObject() {
      this.header.paid_amount = "0.00";
      this.field.apply_unused_amount = parseFloat(
        this.field.unused_amount
      ).toFixed(2);
    },
    invoicecreditsincustomerdetails() {
      var check =
        this.field.type == "retainer"
          ? "availableretainerinvoice"
          : this.field.type == "payment" || this.field.type == "customeradvance"
          ? "availablepaymentinvoice"
          : "availablecreditinvoice";

      store
        .dispatch(
          "general/" + check,
          JSON.stringify({ id: this.field.crdt_id })
        )
        .then(() => {
          this.items = this.invoice_details;
        });
    },

    onSubmit() {
      this.submitted = true;
      if (Object.entries(this.checkCustomerAdvance).length > 0) {
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message:
            "Cannot apply Customer Payment to Invoice, Since it has different Place Of Supply.",
          type: "danger",
          showCloseButton: true
        });
        return;
      }
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$refs.availableinvoice.hide();
          this.submitted = false;
          var submit =
            this.field.type == "retainer"
              ? "updateRetainerInvoice"
              : this.field.type == "payment"
              ? "updatePaymentInvoiceInvoice"
              : this.field.type == "customeradvance"
              ? "updateCustomerAdvanceInvoice"
              : "updateCreditInvoice";

          var data = JSON.stringify({
            id: this.field.crdt_id,
            field: {
              id: this.field.id,
              paid_amount: this.header.paid_amount,
              unused_amount: this.field.apply_unused_amount
            },
            items: this.items
          });
          store.dispatch("general/" + submit, data).then(() => {
            this.submitted = false;
            this.unused_credits =
              parseFloat(this.unused_credits) -
              parseFloat(this.header.paid_amount);
            this.due_amount =
              parseFloat(this.due_amount) - parseFloat(this.header.paid_amount);
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: "Credit amount applied to invoice successfully.",
              type: "success",
              showCloseButton: true
            });
          });
        } else {
          this.submitted = false;
          this.error_show = true; // show validation message
        }
      });
    }
  },
  mounted() {
    EventBus.$on(
      "invoicecreditsincustomerdetails",
      this.invoicecreditsincustomerdetails
    ); // to trigger the method from parentcomponent
    EventBus.$on("emittedFieldData", data => {
      this.field = data;
    });
  },
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    ...mapState({
      invoice_details: state => state.general.customer_invoice_details
    }),
    unused_credits: {
      get() {
        return this.$store.state.customer.listView.unused_credits
          .total_unused_credits;
      },
      set(val) {
        this.$store.state.customer.listView.unused_credits.total_unused_credits = val;
      }
    },
    due_amount: {
      get() {
        return this.$store.state.customer.listView.unused_credits.due_amount;
      },
      set(val) {
        this.$store.state.customer.listView.unused_credits.due_amount = val;
      }
    }
  }
};
</script>
<style>
.required:after {
  color: #e32;
  content: " *";
  display: inline;
}
</style>
